export const STANDARD_LISTVIEW_PADDING = '20px 24px 0px 24px';

export const LISTVIEW_NO_TOP_PADDING = '0px 24px';

// In order to view the advanced filters's active dot
export const LISTVIEW_FULL_SCREEN_MODAL_NO_TOP_PADDING = '5px 24px 0px 24px';

export const DEFAULT_LANGUAGE_CODE = 'fr';
